/**
 * Account › Team seats, counted as the server counts them (apiserver
 * campaignRole.js seatsInUse): members, the Campaign role included, and
 * paused people, who keep their places. Technical support uses none.
 * When every seat is taken there's no invite form, but a note saying what to
 * do: upgrade (the owner) or ask the owner (owner 2026-10-31).
 */
export function teamSeats({
  members,
  paused,
  cap,
  planName,
  youOwn,
  ownerEmail,
}: {
  /** Members who use a seat (technical support left out). */
  members: number;
  paused: number;
  cap: number;
  planName: string | null;
  youOwn: boolean;
  ownerEmail: string | null;
}) {
  const used = members + paused;
  const full = used >= cap;
  const plan = planName ? `${planName} plan` : 'plan';
  const taken =
    cap === 1 ? 'member, and that seat is taken' : `members, and all ${cap} seats are taken`;
  const next = youOwn
    ? 'Upgrade your plan to invite more people.'
    : `Ask the site owner${ownerEmail ? `, ${ownerEmail},` : ''} to upgrade the plan to invite more people.`;
  return { used, full, note: full ? `Your ${plan} includes ${cap} team ${taken}. ${next}` : null };
}
